module.exports = __webpack_public_path__ + "static/media/veris_logo.4fc41681.svg";